import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import TextField from "@mui/material/TextField";
const phoneInput = (props, ref) => {
    return _jsx(TextField, Object.assign({}, props, { required: true, inputRef: ref, variant: "outlined", name: "phone", type: "tel" }));
};
export default forwardRef(phoneInput);
